export default __webpack_public_path__ + "static/dot-map-bottom-f1ab539ca8022e587ed825c207bc259d.svg";